// extracted by mini-css-extract-plugin
export default {"bonusBlock":"BonusItemBlock_bonusBlock__jPx40","bonusBlockContent":"BonusItemBlock_bonusBlockContent__fdIqS","bonusBlock_completed":"BonusItemBlock_bonusBlock_completed__yN-2W"};